import { Injectable } from '@angular/core';

import { TeaserBetConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { PickBalanceOptionPreCheckError } from '../../../errors/pre-check/pick-balance-option-pre-check-error';
import { TeaserBetPickValidationContext } from '../../../models/models';
import { ITeaserBetPickValidator } from './validators';

@Injectable()
export class PickBalanceOptionValidator implements ITeaserBetPickValidator<PickBalanceOptionPreCheckError> {
    constructor(private teaserBetConfig: TeaserBetConfig) {}

    validate(pick: BetslipPick, context: TeaserBetPickValidationContext): PickBalanceOptionPreCheckError[] {
        const shouldCheckPickBalanaceOption =
            this.teaserBetConfig.isEnabled &&
            pick instanceof BetslipV1Pick &&
            pick.teaser?.crossLeagueIds?.length > 0 &&
            pick.teaser?.crossSportIds?.length > 0;

        if (!shouldCheckPickBalanaceOption) {
            return [];
        }

        const teaserPick = context.picks[pick.id.toString()];

        return teaserPick?.isNonBalancedPick ? [new PickBalanceOptionPreCheckError(pick.id.toString())] : [];
    }
}
